import React from 'react'
import { graphql } from 'gatsby'

import Layout from '../components/Layout'
import Event from '../components/Event'

export default ({ location, data, pageContext }) => (
  <Layout
    pageTitle={data.allContentfulPageEvent.edges[0].node.pageTitle}
    location={location}
    locale={pageContext.locale}
  >
    <Event data={data.allContentfulPageEvent.edges[0].node} />
  </Layout>
)

export const eventQuery = graphql`
  query($locale: String) {
    allContentfulPageEvent(filter: { node_locale: { eq: $locale } }) {
      edges {
        node {
          pageTitle
          isGalleryVisible
          images {
            description
            fluid(maxWidth: 1280) {
              ...GatsbyContentfulFluid
            }
          }
          section1 {
            childMarkdownRemark {
              html
            }
          }
          section2 {
            childMarkdownRemark {
              html
            }
          }
        }
      }
    }
  }
`
